// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3c7b8d0f","183":"ac59fc59","810":"892ef556","828":"cc6c9d93"}[chunkId] + ".chunk.js";
};